
// 增加本地存储
function Storage(options) {
    this.config = this.extend(this.extend({}, config), options);
}

// 原型方法
var sp = Storage.prototype;

sp.support = function() {
    if (typeof window === 'undefined') {
        return false;
    }

    var tk = 'test',
        storage = window.sessionStorage;

    try {
        storage.setItem(tk, 1);
        storage.removeItem(tk);
        return !0;
    } catch(e) {
        alert('您可能启用了无痕浏览模式，开启后将无法为您节省流量且会导致部分功能无法使用，建议关闭无痕浏览后继续访问。');
        return !1;
    }
}();

/**
 * 合并方法
 * @return {[type]} [description]
 */
sp.extend = function(dest, src) {
    if(dest && typeof dest == 'object' &&  src && typeof src == 'object') {
        for(var i in src) {
            src[i] && (dest[i] = src[i]);
        }
    }

    return dest;
}

/**
 * 重置key值
 * @param  string key 本地存储key值
 * @return {[type]}     [description]
 */
sp.getKey = function(key) {
    return (key+'').toUpperCase();
}

/**
 * 在当前时间基础上增加时间
 * @param  int second 增加的ms数
 * @return {[type]}        [description]
 */
sp.getTime = function(second) {
    return +new Date() + ( + second || 0);
}

/**
 * 设置过期时间
 * @param int second 保存的时间
 */
sp.setExpiredTime = function(second) {
    this.config.timeout = parseInt(second, 10);

    return this;
}

/**
 * 缓存值至本地媒介
 * @param string key   缓存key值
 * @param string value 缓存值
 */
sp.set = function(key, value, timeout) {
    var _this = this;
    var type = this.config.type;
    key = this.getKey(key);

    var cachetime = this.getTime(timeout || this.config.timeout);
    // 更新本地存储
    if(value && typeof value == 'function') {
        value = value(_this.get(key));
    }
    var val = {
        data: value,
        timeout: cachetime,
        savetime: this.getTime()
    };
    val = JSON.stringify(val);

    this.setItem(type, key, val);

    return this;
}

/**
 * 获取缓存在本地的值
 * @return all 缓存在本地的值
 */
sp.get = function(key) {
    var _this = this;
    var type = this.config.type;
    key = this.getKey(key);

    // 获取本地缓存
    var val;
    val = this.getItem(type, key);

    // 本地存储是否过期
    val = val && JSON.parse(val);
    if(val && (val.timeout > _this.getTime())) {
        return val.data;
    } else {
        _this.clear(key);
    }

    return null;
}

/**
 * 删除本地存储的值
 * @param  string key 本地存储标识
 * @return {[type]}     [description]
 */
sp.clear = function(key) {
    var type = this.config.type;
    key = this.getKey(key);

    this.removeItem(type, key);

    return this;
};

/**
 * 设置本地存储信息
 * @param type
 * @param key
 * @param value
 */
sp.setItem = function(type, key, val) {
    var support = this.support,
        _this = this,
        old;


    if(support) {
        window[type+'Storage'].setItem(key, val);
    } else {
        old = _this.getWindowName();
        old[key] = val;
        _this.setWindowName(old);
    }
};

/**
 * 获取本地存储信息
 * @param type
 * @param key
 */
sp.getItem = function(type, key) {
    var support = this.support,
        _this = this,
        value;

    if(support) {
        value = window[type+'Storage'].getItem(key);
    } else {
        value = _this.getWindowName();
        value = value && value[key];
    }

    return value;
};

/**
 * 清除本地存储信息
 * @param type
 * @param key
 * @returns {*}
 */
sp.removeItem = function(type, key) {
    var support = this.support,
        _this = this,
        value;

    if(support) {
        value = window[type+'Storage'].removeItem(key);
    } else {
        value = _this.getWindowName();
        value && (delete value[key]);
        _this.setWindowName(value);
    }
};

/**
 * 获取window.name
 * @returns {*|Window.name}
 */
sp.getWindowName = function() {
    if (typeof window === 'undefined') {
        return {};
    }

    var value = window.name;

    try {
        value = JSON.parse(value);
    } catch (e) {
        value = {};
    }

    return value;
};

/**
 * 设置window.name
 * @param value
 */
sp.setWindowName = function(value) {
    if (typeof window === 'undefined') {
        return false;
    }
    value = value || {};

    window.name = JSON.stringify(value);
};

var config = {
    timeout: 365*24*60*60*1000, // 过期时间
    type: 'local' // 存储媒介
};

export default Storage;



// WEBPACK FOOTER //
// libs/plugins/storage/Storage.js